import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './';
import { NavigationTab } from '../../types/common';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  // Define navigation tabs as per requirements
  const navigationTabs: NavigationTab[] = [
    {
      id: 'home',
      label: 'Home',
      href: '/',
      isActive: location.pathname === '/'
    },
    {
      id: 'solutions',
      label: 'Solutions',
      href: '/solutions',
      isActive: location.pathname.startsWith('/solutions')
    },
    {
      id: 'agents',
      label: 'Agents',
      href: '/agents',
      isActive: location.pathname === '/agents'
    },
    {
      id: 'content',
      label: 'Blogs',
      href: '/content',
      isActive: location.pathname === '/content'
    }
  ];

  // Determine current page for header
  const getCurrentPage = () => {
    if (location.pathname === '/') return 'home';
    if (location.pathname.startsWith('/solutions')) return 'solutions';
    if (location.pathname.startsWith('/gtm')) return 'gtm';
    if (location.pathname === '/content') return 'content';
    if (location.pathname === '/agents') return 'agents';
    if (location.pathname === '/contact') return 'contact';
    return 'unknown';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header 
        currentPage={getCurrentPage()}
        navigationTabs={navigationTabs}
      />
      {children}
    </div>
  );
};

export default Layout;